import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import routes from "@/common/routes"
import store from './store'
import Toaster from "@meforma/vue-toaster";
//import { s3Layer } from 'vue3-layer';
//import 'vue3-layer/dist/s3Layer.css';

import {post,get} from "./common/request"


const app = createApp(App)
app.config.globalProperties.$post = post
app.config.globalProperties.$get = get
app.config.globalProperties.$routes = routes
app.config.globalProperties.$store = store

app.use(Toaster)
//app.component('s3-layer', s3Layer);

app.use(router).mount('#app')
